<template>
    <span>
        <span @click="openModal()"><slot /></span>
        <b-modal v-model="showModal" size="lg">
            <template #modal-header>
                <h3 v-if="!initialValues" v-translate>Add new product</h3>
                <h3 v-if="initialValues" v-translate>Edit product</h3>
                <GekkoButton 
                    @click="closeModal()"
                    icon="fa-solid fa-xmark"
                    variant="link"
                    class="close text-unassigned"
                />
            </template>
            <template #default>
                <b-form id="product-create-form" @submit.stop.prevent>
                    <b-alert :show="showDismissibleCountdown" variant="danger" dismissible @dismissed="showDismissibleCountdown=0" v-translate>
                      A product with this name already exists.
                    </b-alert>
                    <b-form-group id="input-group-1" label-cols-sm="3" content-cols-md="5" label-align-sm="right" label-class="gk-label-margin" :label="$gettext('Description*')" label-for="input-1">
                        <b-form-input id="input-1" v-model="item.description" required></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-cols-sm="3" content-cols-md="5" label-align-sm="right" label-class="gk-label-margin" :label="$gettext('Amount*')" label-for="input-2">
                        <b-input-group >
                            <b-form-input id="input-2" type="number" v-model="item.amount" required></b-form-input>
                            <b-form-select id="input-2" v-model="item.amount_is_gross" :options="priceOptions" required></b-form-select>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group id="input-group-3" label-cols-sm="3" content-cols-md="5" label-align-sm="right" label-class="gk-label-margin" :label="$gettext('Tax rate*')" label-for="input-3">
                        <VatInput v-model="item" countryCode="window.company_country"></VatInput>
                    </b-form-group>
                    <b-form-group id="input-group-4" label-cols-sm="3" content-cols-md="5" label-align-sm="right" label-class="gk-label-margin" :label="$gettext('Group')" label-for="input-4">
                        <b-form-select id="input-4" v-model="item.group" :options="groupOptions" value-field="id" text-field="name"></b-form-select>
                    </b-form-group>
                </b-form>
            </template>
            <template #modal-footer>
                <GekkoButton 
                    @click="closeModal()"
                    :text="$gettext('Cancel')"
                    variant="link"
                    class="mr-auto px-0 text-primary"
                />
                <GekkoButton 
                    @click="addProduct()"
                    :text="$gettext('Save')"
                    form="product-create-form"
                    type="submit"
                />
            </template>
        </b-modal>
    </span>
</template>

<script>
import ProductGroupService from "@/store/services/productgroup.service.js";
import UserService from "@/store/services/user.service.js";
import CompanyService from "@/store/services/company.service.js";
import VatInput from "@/components/VatInput.vue";
import ProductService from "@/store/services/product.service.js";
import GekkoButton from "@/components/GekkoButton";

export default {
    name: "CreateProduct",
    components: {
        VatInput, GekkoButton
    },
    props: {
        initialValues: Object,
        initialGroup: Number,
        createdCallback: {type: Function}
    },
    data() {
        return {
            isPremium: false,
            showDismissibleCountdown:0,
            item: this.$props.initialValues || {
                amount_is_gross: false,
                archived: false,
                company_profile: window.company_id,
                total_inc_vat: false,
                vat_exempt: false,
                group: this.$props.initialGroup || 0
            },
            showModal: false,
            groupOptions: [],
            priceOptions: [
                {value: false,text: this.$gettext("Price (ex. VAT)")},
                {value: true,text: this.$gettext("Price (incl. VAT)")}
            ],
        }
    },
    created(){
    },
    methods: {
        openModal(){
            var vm = this;
            this._getProductGroups();
            UserService.retrieveCurrent({extended: 'True'}).then(function(response){
                vm.isPremium = response.data.is_premium;
            });
            if(!vm.$props.initialValues){
                vm.item.amount = null;
                vm.item.description = null;
                vm.item.group = null;
                CompanyService.getCurrent().then(function (response) {
                    if(!response.data.default_tax_rate_exempt)
                        vm.item.tax_rate = response.data.default_tax_rate;
                    else {
                        vm.item.tax_rate = 21;
                        vm.item.vat_exempt = true;
                    }
                    vm.showModal = true;
                });
            }else{
                vm.showModal = true;
            }
        },
        closeModal(){
            this.showModal = false;
        },
        addProduct(){
            var vm = this;
            if(!this.isPremium){
                vm.$store.commit('togglePremiumModal');
                return;
            }
            if(this.initialValues) {
                ProductService.update(vm.initialValues.id, vm.initialValues).then(function () {
                    vm.createdCallback();
                    vm.closeModal();
                }).catch(function (response) {
                    if (response['non_field_errors']) {
                        vm.showDismissibleCountdown = 2;
                    }
                })
            }else{
                if(!this.item.group){
                    delete this.item.group;
                }
                ProductService.create(this.item).then(function () {
                    vm.createdCallback();
                    vm.closeModal();
                }).catch(function (response) {
                    if (response['non_field_errors']) {
                        vm.showDismissibleCountdown = 2;
                    }
                })
            }
        },
        _getProductGroups(){
            var vm = this;
            ProductGroupService.list({company_profile:window.company_id}).then(function (response) {
                vm.groupOptions = response.data;
                vm.groupOptions.unshift({id:'', name:'---'});
            });
        }
    },
    computed: {
    }
};
</script>
<style >

</style>
